import React from "react";
import { Box, Typography } from "@material-ui/core";
import { LogoIcon } from "assets";

type Props = {
  imageUrl: string | null;
  title: string;
  // Trailing content (controls and/or action icons); right-aligned since the
  // title takes the remaining space.
  children: React.ReactNode;
};

// Shared presentational row for the template exercise/lesson lists: a 40px
// thumbnail (or logo fallback), the title, trailing content, and a full-width
// bottom delimiter — so both lists render identically.
const TemplateItemRow: React.VFC<Props> = ({ imageUrl, title, children }) => (
  <Box display="flex" alignItems="center" style={{ gap: 16, padding: "8px 0", borderBottom: "1px solid #eee" }}>
    {imageUrl ? (
      <img
        alt=""
        src={imageUrl}
        height={40}
        width={40}
        style={{ objectFit: "cover", borderRadius: 4, flexShrink: 0 }}
      />
    ) : (
      <LogoIcon title="Joint Academy" style={{ height: 40, width: 40, flexShrink: 0 }} />
    )}
    <Typography variant="subtitle2" style={{ minWidth: 140, flexGrow: 1 }}>
      {title}
    </Typography>
    {children}
  </Box>
);

export default TemplateItemRow;
